import { Alert, Button, TextField } from "@mui/material";
import Logger from "../../../services/Logger";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import AnythingService from "../AnythingService";

export default function WordSearchPlaceWordsMain() {
    const [tplId, setTplId] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handlePlaceWords = async () => {
        if (!tplId || !tplId.trim()) {
            setError("Please enter a puzzle template ID");
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(null);

        try {
            const result = await AnythingService.placeWordsOnWordSearch(tplId.trim());
            
            if (result) {
                setSuccess(`Successfully placed words on word search puzzle ${tplId}`);
            } else {
                setError("Failed to place words. Please check the puzzle ID and try again.");
            }
        } catch (err) {
            Logger.error("Place words error:", err);
            setError(err.message || "Failed to place words. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handlePlaceWords();
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", maxWidth: 600 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Place Words on Word Search Puzzle
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Enter a puzzle template ID to replace the words on a word search puzzle.
            </Typography>
            <TextField
                label="Puzzle Template ID"
                variant="outlined"
                value={tplId}
                onChange={(e) => {
                    setTplId(e.target.value);
                    setError(null);
                    setSuccess(null);
                }}
                onKeyPress={handleKeyPress}
                fullWidth
                placeholder="Enter puzzle template ID"
                disabled={loading}
            />
            <Box>
                <Button 
                    variant="contained" 
                    onClick={handlePlaceWords}
                    disabled={loading}
                >
                    {loading ? "Placing Words..." : "Place Words"}
                </Button>
            </Box>
            {error && (
                <Alert severity="error">
                    {error}
                </Alert>
            )}
            {success && (
                <Alert severity="success">
                    {success}
                </Alert>
            )}
        </Box>
    );
}
